import { buildService } from './decorated-service';
import config from '../../../config';
import { DeepPartialProfileArgs } from '../../../core/types/return-journey-profile';
import {
  isEmptyObject,
  navigateToExternal,
  withDefault
} from '../../../core/util';
import { consumerTypes } from '../utils';

const ProfileService = buildService(
  '/nasu-svc/service/new-account-application'
);

export const saveJourneyProfile = (
  args: DeepPartialProfileArgs
): Promise<any> => {
  return ProfileService.http.put('/', args);
};

export const deleteJourneyProfile = (applicationID: any): Promise<any> => {
  return ProfileService.http.del(applicationID);
};

export const createNewJourneyProfile = (
  args: DeepPartialProfileArgs
): Promise<any> => {
  return ProfileService.add(args);
};

export const handleServiceResponse = (resp: any): Promise<any> | void => {
  if (resp?.status === 400 || resp?.status === 401) {
    const emailScreenUrl = `${config(
      'returnUrlPrefix'
    )}personal-investing/new-account/setup/return-journey/email`;
    return navigateToExternal(emailScreenUrl);
  }
  return resp;
};

export const getApplicationDetailsByID = async (
  profileID: string | undefined
): Promise<any> => {
  if (!profileID)
    throw new TypeError('getApplicationDetailsByID expected a valid profileID');

  return ProfileService.view(profileID, {
    handleServiceResponse
  });
};

// ACCOUNT APPLICATION SUMMARY SERVICE
const ProfileSummaryService = buildService(
  `/nasu-svc/service/new-account-application-summary`
);

export const getExistingApplications = async (
  emailAddress: string | undefined,
  accountType: string | undefined
): Promise<any> => {
  const result = await ProfileSummaryService.http.get(
    '/',
    { query: { emailAddress, accountType } },
    { ignoreServiceFailure: true }
  );
  return isEmptyObject(result) || result.httpStatusCode > 200 ? [] : result;
};

export const getAllApplicationsByEmail = async (
  emailAddress: string | undefined
): Promise<any> => {
  if (!emailAddress)
    throw new TypeError(
      'getAllApplicationsByEmail expected a valid emailAddress'
    );

  const result = await ProfileSummaryService.http.get(
    '/',
    { query: { emailAddress } },
    { ignoreServiceFailure: true }
  );

  return isEmptyObject(result) || result.httpStatusCode > 200 ? [] : result;
};

// Support Functions
export const retrieveFilterAndAssignAppID = async (
  primaryEmailAddress: any,
  accountType: string | undefined
): Promise<string> => {
  const existingApplications = await getExistingApplications(
    primaryEmailAddress,
    accountType
  );

  // filter applications which does not belong to 'FRONT_OFFICE_NASU'
  const filterExistingApps =
    !isEmptyObject(existingApplications) &&
    existingApplications?.filter(
      appID => appID.consumerName !== consumerTypes.FONASU
    );

  // get profile ID of first application
  const existingApplicationID = filterExistingApps?.[0]?.applicationID;
  return withDefault(existingApplicationID, '');
};
